export const INFO_MODAL_CONSTANT = {
    STAGE_1: {
        modalContent: 'stage 1 Bonuses',
        primaryText: {
            startingtext: 'Starting price of AUD',
            value: '$0.10.',
            bonus: 'Referral Bonus',
            bonus0: ' ',
            bonus1: ' ',
            bonus2: ' ',
            bonus3: 'Staking Bonuses awarded of 1% per month for 18 months to a maximum 250,000 tokens',
            bonus4: 'Directly Receive 15% Extra PIP Bonus on purchases over AUD $2,000',
            bonus5: 'Directly Receive 20% Extra PIP Bonus on purchases over AUD $5,000'

        },
        secondaryText: {
                        showButton: true,
                        buttonText: 'No'
                    }
    },
    STAGE_2: {
        modalContent: 'stage 2 Bonuses',
        primaryText: { 
            bonus: 'Referral Bonus',
            bonus0: ' ',
            bonus1: ' ',
            bonus2: ' ',
            bonus3: 'Staking Bonuses awarded of 0.8% per month for 18 months to a maximum 200,000 tokens',
            bonus4: 'Directly Receive 10% Extra PIP Bonus on purchases over AUD $2,000',
            bonus5: 'Directly Receive 10% Extra PIP Bonus on purchases over AUD $5,000'

        },
        secondaryText: {
            showButton: true,
            buttonText: 'No'
        }
    },
    STAGE_3: {
        modalContent: 'stage 3 Bonuses',
        primaryText: { 
            bonus: 'Referral Bonus',
            bonus0: ' ',
            bonus1: ' ',
            bonus2: ' ',
            bonus3: 'Staking Bonuses awarded of 0.7% per month for 12 months to a maximum 150,000 tokens',
            bonus4: 'Directly Receive 10% Extra PIP Bonus on purchases over AUD$2,000',
            bonus5: 'Directly Receive 10% Extra PIP Bonus on purchases over AUD$5,000'
        },
        secondaryText: {
            showButton: true,
            buttonText: 'No'
        }
    },
    STAGE_4: {
        modalContent: 'stage 4 Bonuses',
        primaryText: { 
            bonus: 'Referral Bonus',
            bonus0: ' ',
            bonus1: ' ',
            bonus2: ' ',
            bonus3: 'Staking Bonuses awarded of 0.6% per month for 12 months to a maximum 100,000 tokens',
            bonus4: 'Directly Receive 10% Extra PIP Bonus on purchases over AUD$2,000',
            bonus5: 'Directly Receive 15% Extra PIP Bonus on purchases over AUD$5,000'
        },
        secondaryText: {
            showButton: true,
            buttonText: 'No'
        }
    },
    
};